<mat-form-field class="form-group">
    <mat-label>{{ label }}</mat-label>
    <mat-date-range-input [formGroup]="frm" [rangePicker]="picker" class="text-Create form-control">
      <input matStartDate [formControlName]="formControlNameInit" placeholder="Fecha Inicial">
      <input matEndDate [formControlName]="formControlNameEnd" placeholder="Fecha Final">
    </mat-date-range-input>
    <!-- <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint> -->
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  
    <!-- @if (frm.controls.start.hasError('matStartDateInvalid')) {
      <mat-error>Fecha de inicio invalida</mat-error>
    }
    @if (frm.controls.end.hasError('matEndDateInvalid')) {
      <mat-error>Fecha de fin invalida</mat-error>
    } -->
  </mat-form-field>
  
  <!-- <p>Selected range: {{frm.value | json}}</p> -->